import Collection from './generic/collection'
import { FetchData } from './utils/fetchData'
import Preloader from './preloader'
import { onAjaxContentLoaded } from "./generic/evented";
import { getObjFromFormData } from './utils/getObjFromFormData'
import FormValidation from './forms/formValidation'
import CatalogFilter from './catalogFilter'

class AddToCart {
    constructor(instance) {
        this.instance = instance
        this.bindEvents()
    }

    toggleActive(response) {
        try {
            if (response.success) {
                this.instance.classList.toggle('active')
                console.debug('Success');
            }
        } catch {
            console.debug('Error in request data')
        }
    }

    async add(e) {
        e.stopPropagation()
        e.preventDefault()

        let linkId = this.instance.id || this.instance.dataset.jsAddToCart;
        let cfg = JSON.parse(this.instance.dataset?.jsAddToCartCfg ?? "{}") || {};
        let ajaxUrl = this.instance.dataset.jsAjaxUrl
        let response;
        let data;

        if(!!cfg.isCollectDataFromCatalogForm && !!cfg.form) {
            // TODO: добавить валидацию
            const form = document.getElementById(cfg.form)
            if (CatalogFilter.instance.form === form) {
                data = CatalogFilter.instance.catalogFormData
            } else {
                data = getObjFromFormData(new FormData(form))
            }
        } else {
            data = { data: linkId }
        }

        if (process.env.NODE_ENV === "development") {
            console.debug(data)
            response = await FetchData.getData(ajaxUrl)
        } else {
            response = await FetchData.postData(data, ajaxUrl)
        }


        this.toggleActive(response)
        Preloader.hide()
    }

    bindEvents() {
        this.instance.addEventListener('click', (e) => this.add(e))
    }
}

export class AddToCartCollection extends Collection {
    static selectors = {
        instance: '[data-js-add-to-cart]',
    }

    constructor() {
        super(AddToCartCollection.selectors.instance, AddToCart)
        this.bindEvents();
    }

    bindEvents () {
        onAjaxContentLoaded(() => {
            this.init()
        })
    }

    init() {
        $(AddToCartCollection.selectors.instance).each((index, el) => {
            const instance = this.collection.find(element => element.instance === el)
            if (!instance) {
                this.collection = new AddToCart(el)
            }
        })
    }
}
